import useSimpleDialog from '@eversports/react-components/logical/useSimpleDialog'
import { SimpleDialogContent, SimpleDialogTitle } from '@eversports/react-components/patterns/SimpleDialog'
import Dialog from '@eversports/react-components/primitives/Dialog'
import Text from '@eversports/react-components/primitives/Text'
import { makeStyles } from '@mui/styles'
import React from 'react'

import { Localized } from '../../localization/react'

interface Props {
  conditions: string
}

const useStyles = makeStyles({
  pointer: {
    cursor: 'pointer',
  },
})

const VoucherConditions: React.FC<React.PropsWithChildren<Props>> = ({ conditions }) => {
  const classes = useStyles()
  const { showDialog, handleOpen, handleClose } = useSimpleDialog()

  return (
    <>
      <Text color="primary.main" size="small" className={classes.pointer} onClick={handleOpen}>
        <Localized id="voucher-conditions" />
      </Text>
      <Dialog open={showDialog} onClose={handleClose}>
        <SimpleDialogTitle type="info" handleClose={handleClose}>
          <Localized id="voucher-conditions" />
        </SimpleDialogTitle>
        <SimpleDialogContent>
          <Text>{conditions}</Text>
        </SimpleDialogContent>
      </Dialog>
    </>
  )
}

export default VoucherConditions
